import retry from "async-retry";
import axios from "axios";
import { message } from "antd";
import { useNavigate } from 'react-router-dom';
let navigate; // Store the navigate function

export const injectNavigate = (nav) => { // Export a function to inject navigate
  navigate = nav;
};

export const checkStatus = (response) => {
  if (response.status === 200 || response.status === 201) {
    localStorage.setItem("access", true);
    return response;
  } else if (response.status === 401) {
    if (localStorage.getItem("access") != null) {
      localStorage.removeItem("access");
      localStorage.removeItem("authToken"); // Remove only authentication-related items
      localStorage.removeItem("pingAccessToken");
      message.error("Session expired, redirecting to login screen!");
      if (navigate) {
        navigate('/login');
      } else {
        setTimeout(() => window.location.replace('/login'), 3000);
      }
    }
  }
  return response; // Return response even for other status codes
};
function headerRequest() {
  const authtoken = localStorage.getItem("authToken");
  let authType =
    localStorage.getItem("pingAccessToken") !== null
      ? "PING_AUTH"
      : "PASSCODE_AUTH";
  return {
    // 'Access-Control-Allow-Origin': '*',
    Accept: "application/json",
    "Content-Type": "application/json",
    authType: `${authType}`,
    // 'X-Frame-Options':'deny',
    // 'Content-Security-Policy':'script-src self',
    // 'X-Permitted-Cross-Domain-Policies':'none',
    // 'X-XSS-Protection': '1 mode=block',
    "x-authtoken": `${authtoken}`,
    Authorization: `${authtoken}`,
    // "Access-Control-Allow-Methods": "POST",
    // "Access-Control-Allow-Headers": "Content-Type, Authorization"
  };
}
export const fetch_retry_post = async (endpoint, payload) => {
  try {
    return await retry(
      async () => {
        const response = await axios.post(endpoint, JSON.stringify(payload), {
          headers: headerRequest(),
        });
        checkStatus(response);
        return response;
      },
      {
        retries: 0,
      }
    );
  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};

export const fetch_retry_put = async (endpoint, payload) => {
  try {
    return await retry(
      async () => {
        const response = await fetch(endpoint, {
          // headers: {

          //   Accept: "application/json",
          //   "Content-Type": "application/json",
          // },
          headers: headerRequest(),
          method: "put",
          body: JSON.stringify(payload),
        });
        checkStatus(response);
        return response;
      },
      {
        retries: 0,
      }
    );
  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};

export const fetch_retry_delete = async (endpoint, payload) => {
  try {
    return await retry(
      async () => {
        const response = await fetch(endpoint, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "delete",
          body: JSON.stringify(payload),
        });
        checkStatus(response);
        return response;
      },
      {
        retries: 0,
      }
    );
  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};

export const fetch_retry_get = async (endpoint) => {
  try {
    return await retry(
      async () => {
        const response = await axios.get(endpoint, {
          headers: headerRequest(),
        });
        checkStatus(response);
        return response;
      },
      {
        retries: 0,
      }
    );
  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};

export const xmlGETRequest = async (endpoint) => {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", endpoint, true);

  xhr.responseType = "arraybuffer";
  xhr.onload = function (e) {
    if (this.status === 200) {
      var blob = new Blob([this.response], { type: "application/pdf" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Report_" + new Date() + ".pdf";
      link.click();
    }
  };
  xhr.send();
};

export const downloadFile = async (endpoint, payload, fileName) => {
  try {
    const downloadResponse = await axios
      .post(endpoint, JSON.stringify(payload), {
        headers: headerRequest(),
        responseType: "blob",
      })
      .then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);

        // create "a" HTML element with href to file & click
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName + ".csv"); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
      return { success: false, message:downloadResponse };

  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};
